import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[750px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20Korean%20manhwa%20style%20illustration%2C%20dramatic%20composition%20with%20multiple%20manga%20panels%20floating%20in%20space%2C%20deep%20dark%20background%20with%20subtle%20gradients%2C%20abstract%20ink%20wash%20effects%2C%20mysterious%20and%20artistic%20vibe%2C%20no%20text%2C%20dark%20moody%20atmosphere%20with%20hints%20of%20warm%20amber%20accents%2C%20vertical%20composition%20suitable%20for%20website%20hero%20background&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-10 lg:gap-16">
          <div className="flex-1 pt-20 md:pt-0">
            <div className="flex items-center gap-3 mb-5">
              <div className="flex -space-x-2">
                <div className="w-9 h-9 rounded-full border-2 border-background-950 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Young%20Asian%20person%20avatar%20portrait%2C%20simple%20dark%20background%2C%20clean%20minimal%20style%2C%20soft%20lighting&width=100&height=100&seq=hero-avatar-1&orientation=squarish"
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-9 h-9 rounded-full border-2 border-background-950 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20avatar%20portrait%2C%20simple%20dark%20background%2C%20clean%20minimal%20style%2C%20soft%20lighting&width=100&height=100&seq=hero-avatar-2&orientation=squarish"
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-9 h-9 rounded-full border-2 border-background-950 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Young%20Asian%20man%20avatar%20portrait%2C%20simple%20dark%20background%2C%20clean%20minimal%20style%2C%20soft%20lighting&width=100&height=100&seq=hero-avatar-3&orientation=squarish"
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <span className="text-sm text-foreground-200 font-medium">
                超过 500 万漫迷的选择
              </span>
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-foreground-50 leading-[1.1]">
              免费阅读
              <br />
              <span className="text-primary-400">韩国漫画</span>
            </h1>

            <p className="mt-6 text-base md:text-lg text-foreground-300 leading-relaxed max-w-lg">
              海量韩漫资源，每日更新，无需注册，随时随地畅享漫画阅读的乐趣
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mt-8">
              <Link
                to="/category/qihuan"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始阅读
                <i className="ri-arrow-right-line text-base"></i>
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-200/40 text-foreground-200 text-sm hover:bg-background-200/60 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>

            <div className="flex flex-wrap items-center gap-6 md:gap-10 mt-10 pt-8 border-t border-foreground-50/10">
              {[
                { value: '12,000+', label: '漫画资源' },
                { value: '500万+', label: '活跃用户' },
                { value: '99.9%', label: '稳定性' },
              ].map((stat) => (
                <div key={stat.label}>
                  <p className="text-2xl md:text-3xl font-heading font-black text-foreground-50">
                    {stat.value}
                  </p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="hidden lg:block flex-1 relative">
            <div className="relative w-full aspect-[4/3]">
              <div className="absolute top-0 left-0 w-[55%] aspect-[2/3] rounded-lg overflow-hidden shadow-2xl z-20">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20cover%20art%2C%20male%20warrior%20protagonist%20with%20dark%20hair%20and%20ancient%20armor%2C%20holding%20a%20glowing%20sword%2C%20dramatic%20battle%20scene%20in%20background%2C%20epic%20fantasy%20style%2C%20golden%20and%20amber%20accents%2C%20dark%20atmospheric%20lighting%2C%20professional%20digital%20illustration&width=600&height=900&seq=hero-comic-left&orientation=portrait"
                  alt="热门韩漫"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute top-4 right-0 w-[65%] aspect-[3/4] rounded-lg overflow-hidden shadow-2xl z-10">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20manhwa%20cover%2C%20elegant%20female%20lead%20in%20traditional%20hanbok%2C%20cherry%20blossom%20petals%2C%20soft%20dreamy%20atmosphere%2C%20warm%20golden%20sunset%20lighting%2C%20romantic%20and%20ethereal%20vibe%2C%20high%20quality%20digital%20art&width=800&height=1066&seq=hero-comic-right&orientation=portrait"
                  alt="热门韩漫推荐"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}